import { buildQuery } from '@/lib/helper';
import client from '@/lib/http-client';

const endpoint = '/admin/handling_fee';

export default {
	getList(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}?${query}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	getScoreBoard(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/scoreboard?${query}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	export(params, cb, errorCb) {
		const url = `${endpoint}/export`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	changeStatus(params, cb, errorCb) {
		const url = `${endpoint}/change_status`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
